import type { HeaderMap } from '../types';
import type { AuthType } from './constants';

export abstract class Authenticator {
  abstract authRequest(
    authType: AuthType,
    payload: Uint8Array,
    headers: HeaderMap
  ): Promise<HeaderMap>;
}
